import { useMutation } from "@apollo/client";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrumb from "../../components/Breadcrumb";
import Card from "../../components/Card";
import { useToast } from "../../components/Toast/toastHook";
import { RESET_USER_PASSWORD } from "../../graphql/agentQueries";
import { Form, Input, Button } from "antd";
import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";

const AgentResetPassword = () => {
  const { companyId } = useParams();
  const navigate = useNavigate();
  const toast = useToast(4000);
  const [form] = Form.useForm();

  const [resetPassword, { loading }] = useMutation(RESET_USER_PASSWORD, {
    onCompleted() {
      toast("success", "Password changed successfully");
      form.resetFields();
      navigate(`/company/${companyId}/agent/dashboard`);
    },
    onError(e) {
      toast("error", e.message);
    },
  });

  const handleSubmit = (values) => {
    if (values.newPassword !== values.confirmPassword) {
      toast("error", "New password and confirm password do not match");
      return;
    }
    resetPassword({
      variables: {
        currentPassword: values.currentPassword,
        password: values.newPassword,
      },
    });
  };

  return (
    <div id="agent-reset-password">
      <Breadcrumb pageName="Reset Password" />
      <div className="pb-6">
        <Card>
          <div className="p-6 max-w-md">
            <Form
              form={form}
              layout="vertical"
              onFinish={handleSubmit}
            >
              <Form.Item
                name="currentPassword"
                label="Current Password"
                rules={[{ required: true, message: "Current password is required" }]}
              >
                <Input.Password
                  placeholder="Enter current password"
                  iconRender={(visible) =>
                    visible ? <EyeOutlined /> : <EyeInvisibleOutlined />
                  }
                />
              </Form.Item>

              <Form.Item
                name="newPassword"
                label="New Password"
                rules={[
                  { required: true, message: "New password is required" },
                  { min: 6, message: "Password must be at least 6 characters" },
                ]}
              >
                <Input.Password
                  placeholder="Enter new password"
                  iconRender={(visible) =>
                    visible ? <EyeOutlined /> : <EyeInvisibleOutlined />
                  }
                />
              </Form.Item>

              <Form.Item
                name="confirmPassword"
                label="Confirm Password"
                rules={[
                  { required: true, message: "Please confirm your password" },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("newPassword") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error("Passwords do not match"));
                    },
                  }),
                ]}
              >
                <Input.Password
                  placeholder="Confirm new password"
                  iconRender={(visible) =>
                    visible ? <EyeOutlined /> : <EyeInvisibleOutlined />
                  }
                />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  className="w-full bg-primary h-12 text-base"
                >
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default AgentResetPassword;
